export default "__VITE_ASSET__DAsTEH7n__"